<mat-form-field>
  <mat-label>
    {{ to.label | translate }}
    @if (to.required) {
      <span class="required"> * </span>
    }
  </mat-label>
  <input class="cursor-pointer" title="mtxDatePicker" [mtxDatetimepicker]="datetimePicker" matInput [formControl]="formControl" (click)="agorDatepicker()" [min]="to.mindyddiad" [max]="to.maxdyddiad" [disabled]="to.disabled" />
  <mtx-datetimepicker-toggle [for]="datetimePicker" matSuffix> </mtx-datetimepicker-toggle>
  <mtx-datetimepicker
    #datetimePicker
    [type]="type(to.type)"
    [mode]="mode(to.mode)"
    [multiYearSelector]="to.multiYearSelector"
    [startView]="startView(to.startView)"
    [twelvehour]="to.twelvehour"
    [timeInterval]="to.timeInterval"
    [touchUi]="to.touchUi"
  ></mtx-datetimepicker>
</mat-form-field>
